
import { ReactNode } from 'react';

interface AuthPageLayoutProps {
  children: ReactNode;
  leftIcon: string;
  leftTitle: ReactNode;
  leftSubtitle: string;
}

export default function AuthPageLayout({
  children,
  leftIcon,
  leftTitle,
  leftSubtitle,
}: AuthPageLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      <div className="hidden md:flex md:w-1/2 bg-gradient-to-br from-primary to-blue-700 relative overflow-hidden items-center justify-center p-12">
        <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none">
          <div className="absolute top-[-10%] left-[-10%] w-96 h-96 bg-white rounded-full mix-blend-overlay filter blur-3xl opacity-30 animate-blob" />
          <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 bg-blue-300 rounded-full mix-blend-overlay filter blur-3xl opacity-30 animate-blob animation-delay-2000" />
        </div>

        <div className="relative z-10 text-center text-white">
          <div className="mb-8 inline-flex items-center justify-center w-32 h-32 bg-white/20 backdrop-blur-sm rounded-full border border-white/30 shadow-2xl">
            <span className="material-icons text-7xl text-white">{leftIcon}</span>
          </div>
          <h1 className="text-4xl lg:text-5xl font-bold mb-4 tracking-tight drop-shadow-md">
            {leftTitle}
          </h1>
          <p className="text-blue-100 text-lg max-w-md mx-auto leading-relaxed opacity-90">
            {leftSubtitle}
          </p>
        </div>

        <div className="absolute bottom-8 left-0 w-full text-center text-blue-200/60 text-xs">
          © 2024 FLUX Financial Platform
        </div>
      </div>

      <div className="flex-1 flex flex-col relative bg-white dark:bg-background-dark">
        {children}
      </div>
    </div>
  );
}
